import { toast } from "react-toastify";
import func, { removePropertiesRecursive } from "../../services/functions";
import mainAxios from "../../services/mainAxios";

export const duplicateInvoice=({invoice,company,t,user,onSuccess})=>{
    const {
      recordDate,
      recordUser,
      modificationDate, 
      modificationUser,
      source,
      customInvoice,
      invoiceHistorics,
      attachmentPath,
      invoiceExtraCharge,
      invoicePrepaidAmount,
      iic,
      fic,
      eic,
      badDebtInv,
      // correctiveInv,
      param3,
      param4,
      qrurl,
      cisStatus,
      cisError,
      ...restInvoice
    } = invoice;
    const pathsToPreservId = ['items','bankAccount','invoiceFees'];
    const cleanedRestInvoice = removePropertiesRecursive(restInvoice, pathsToPreservId);
    cleanedRestInvoice.action = {
      "id": 5,
      "action": "CREATED"
    };
  
    cleanedRestInvoice.status = {
      "id": 7,
      "status": "DRAFT"
    };
    
    cleanedRestInvoice.items = cleanedRestInvoice.items.map(items => {
      const { id,...restItems } = items
      return restItems
    })
    
    cleanedRestInvoice.invoiceFees = cleanedRestInvoice?.invoiceFees?.map(invoiceFee => {
      const { id,...restFee } = invoiceFee
      return {
        ...restFee,
      }
    }) ?? []
  
    cleanedRestInvoice.paymentMethod = cleanedRestInvoice?.paymentMethod?.map(pm => {
      const {
        modificationDate,
        modificationUser,
        customInvoice,
        recordUser,
        recordDate,
        ...restPm } = pm ?? null
        return restPm
    }) ?? []
  
    cleanedRestInvoice.issueDate = new Date()
    cleanedRestInvoice.dueDate = new Date();
    cleanedRestInvoice.internalId = null
    cleanedRestInvoice.opCode = user?.userCompanyOperator?.find(
      (companyOperator) => companyOperator.company === company.id
    )?.operator || null
   
    if (cleanedRestInvoice.businessUnitCode) cleanedRestInvoice.businessUnitCode = cleanedRestInvoice.businessUnitCode.trim();
    if (cleanedRestInvoice.opCode) cleanedRestInvoice.opCode = cleanedRestInvoice.opCode.trim();
    if (cleanedRestInvoice.parties.buyer.name) cleanedRestInvoice.parties.buyer.name = cleanedRestInvoice.parties.buyer.name.trim();
    if (cleanedRestInvoice.parties.seller.name) cleanedRestInvoice.parties.seller.name = cleanedRestInvoice.parties.seller.name.trim();

    return mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(cleanedRestInvoice),
        },
        nuis: company.nuis.trim(),
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(['invoice.isInvoiceDuplicated']), { containerId: "all_toast" })
          onSuccess(res)
        }
      })
}
